import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

const VideoBackground = styled(Box)(() => ({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",

  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.6))",
    zIndex: 1,
  },
}));

/**
 * Переиспользуемый компонент для отображения thumbnail с градиентом
 * Содержит логику выбора лучшего качества thumbnail
 */
export default function ThumbnailBackground({
  content,
  sx = {},
  showGradient = true,
}) {
  if (!content) return null;

  // Приоритет: verticalThumbnails > thumbnails, качество: MAXRES > HIGH > MEDIUM > DEFAULT
  const thumbnails = content.verticalThumbnails || content.thumbnails || [];
  const thumbnail =
    thumbnails.find((t) => t.format === "MAXRES") ||
    thumbnails.find((t) => t.format === "HIGH") ||
    thumbnails.find((t) => t.format === "MEDIUM") ||
    thumbnails.find((t) => t.format === "DEFAULT") ||
    thumbnails[0];

  const backgroundImage = thumbnail
    ? `url(${thumbnail.webpUrl || thumbnail.url})`
    : undefined;

  if (!backgroundImage) return null;

  if (!showGradient) {
    // Простой background без градиента
    return (
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          ...sx,
        }}
      />
    );
  }

  // С градиентом (styled component)
  return <VideoBackground sx={{ backgroundImage, ...sx }} />;
}

ThumbnailBackground.propTypes = {
  content: PropTypes.shape({
    verticalThumbnails: PropTypes.arrayOf(
      PropTypes.shape({
        format: PropTypes.oneOf(["DEFAULT", "MEDIUM", "HIGH", "MAXRES"]),
        url: PropTypes.string.isRequired,
        webpUrl: PropTypes.string,
      })
    ),
    thumbnails: PropTypes.arrayOf(
      PropTypes.shape({
        format: PropTypes.oneOf(["DEFAULT", "MEDIUM", "HIGH", "MAXRES"]),
        url: PropTypes.string.isRequired,
        webpUrl: PropTypes.string,
      })
    ),
  }),
  sx: PropTypes.object,
  showGradient: PropTypes.bool,
};
